module.exports = __webpack_public_path__ + "img/almaza.a3b09d70.jpg";